import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/purchases')({
  staticData: { crumb: 'purchases' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: Outlet,
})
